export default "__VITE_PUBLIC_ASSET__a6cb7810__"